/** Le pagine del programma partner nella console (19/10/2026). Gemello di `en.ts`. */
export default {
  titolo: 'Programma partner',
  sottotitolo: 'Chi ci porta aziende, quanto matura sui loro abbonamenti e quando lo paghiamo.',
  metriche: {
    partner_attivi: 'Partner attivi',
    aziende_attive: 'Aziende che maturano',
    da_decidere: 'Da decidere',
    da_pagare: 'Da pagare',
  },
  schede: {
    partner: 'Partner',
    aziende: 'Aziende',
    liquidazioni: 'Liquidazioni',
    profili: 'Profili e regimi',
    kit: 'Kit dei partner',
  },
  azioni: {
    ricarica: 'Ricarica',
    nuovo_partner: 'Nuovo partner',
    modifica: 'Modifica',
    guarda_spazio: 'Guarda il suo spazio',
    invita: 'Manda l\'invito',
    reinvita: 'Rimanda l\'invito',
    sospendi: 'Sospendi l\'accesso',
    riattiva: 'Riattiva',
    cessa: 'Chiudi il rapporto',
    ricalcola: 'Ricalcola ora',
    ricalcola_tutti: 'Ricalcola tutti',
    abbina: 'Abbina un\'azienda',
    accetta: 'Accetta',
    rifiuta: 'Rifiuta',
    esclusiva: 'Esclusiva',
    esclusiva_regola: 'Torna ai {{mesi}} mesi',
    approva: 'Approva',
    fattura_ricevuta: 'Fattura ricevuta',
    pagata: 'Segna pagata',
    nuovo_profilo: 'Nuovo profilo',
    nuovo_regime: 'Nuovo regime',
    spegni: 'Spegni',
    aggiungi_scaglione: 'Aggiungi uno scaglione',
    togli_scaglione: 'Togli lo scaglione',
    salva: 'Salva',
    annulla: 'Annulla',
    altre_azioni: 'Altre azioni',
    nuovo_materiale: 'Nuovo materiale',
    riaccendi: 'Riaccendi',
  },
  stato_partner: {
    invitato: 'Invitato',
    attivo: 'Attivo',
    sospeso: 'Sospeso',
    cessato: 'Rapporto chiuso',
  },
  stato_abbinamento: {
    registrata: 'Registrata',
    da_decidere: 'Da decidere',
    attiva: 'Matura',
    rifiutata: 'Rifiutata',
    scaduta: 'Scaduta',
  },
  origine: {
    registrazione: 'Registrata dal partner',
    link: 'Dal link del partner',
    a_mano: 'Abbinata a mano',
  },
  stato_liquidazione: {
    bozza: 'Bozza',
    approvata: 'Approvata',
    fattura_ricevuta: 'Fattura ricevuta',
    pagata: 'Pagata',
  },
  soggetto: {
    persona_fisica: 'Persona fisica',
    societa_di_persone: 'Società di persone',
    societa_di_capitali: 'Società di capitali',
  },
  colonne: {
    partner: 'Partner',
    stato: 'Stato',
    profilo: 'Profilo',
    regime: 'Regime',
    aziende: 'Aziende',
    azienda: 'Azienda',
    origine: 'Origine',
    registrata_il: 'Registrata il',
    scade_il: 'Scade il',
    abbonata_dal: 'Abbonata dal',
    periodo: 'Periodo',
    imponibile: 'Provvigioni',
    ritenuta: 'Ritenuta',
    cassa: 'Cassa',
    netto: 'Da bonificare',
    scaglioni: 'Scaglioni',
    trattamento: 'Trattamento',
  },
  filtri: {
    tutti_gli_stati: 'Tutti gli stati',
    cerca: 'Cerca per azienda, partita IVA o partner',
  },
  vuoti: {
    partner: 'Nessun partner. Prima servono un profilo di compenso e un regime fiscale (scheda «Profili e regimi»).',
    aziende: 'Nessuna azienda abbinata o registrata.',
    liquidazioni: 'Nessuna liquidazione: le bozze nascono da sole a fine periodo.',
    profili: 'Nessun profilo di compenso.',
    regimi: 'Nessun regime fiscale.',
    materiali: 'Il kit è vuoto. Crea il primo materiale: l\'invito a iscriversi.',
  },
  partner: {
    aziende_conteggio_one: '{{count}} azienda',
    aziende_conteggio_other: '{{count}} aziende',
    codice: 'Codice {{codice}}',
    entrato: 'È entrato su partner.yumaos.com',
    non_entrato: 'Non è ancora entrato',
    ogni_mesi_one: 'Pagato ogni mese',
    ogni_mesi_other: 'Pagato ogni {{count}} mesi',
    frequenza_piattaforma: 'Frequenza della piattaforma',
    regime_da_scegliere: 'Da scegliere',
    senza_provvigioni: 'Senza provvigioni',
  },
  aziende: {
    scade: 'Scade il {{data}}',
    partita_iva: 'Partita IVA {{chiave}}',
    mai_pagato: 'Non ha ancora pagato',
    contare_dal: 'Le fatture contano dal {{data}}',
    esclusiva_attiva: 'In esclusiva con {{fornitore}} fino al {{data}}',
    esclusiva_finita: 'Esclusiva con {{fornitore}} finita il {{data}}',
    esclusiva_a_mano: 'Decisa a mano',
    esclusive_non_lette: 'Le esclusive dei fornitori non si sono potute leggere: {{motivo}}',
  },
  profili: {
    titolo_profili: 'Profili di compenso',
    aiuto_profili: 'La percentuale sui posti per ogni mese di abbonamento dell\'azienda. I numeri non si cambiano: si crea un profilo nuovo e si spegne il vecchio. Le aziende già portate tengono il profilo che avevano.',
    titolo_regimi: 'Regimi fiscali',
    aiuto_regimi: 'IVA, ritenuta e cassa previdenziale del partner. Tutte facoltative: non per forza c\'è l\'Enasarco.',
    spento: 'Spento',
    scaglione: 'Dal mese {{dal}} al mese {{al}}: {{percentuale}}',
    scaglione_per_sempre: 'Dal mese {{dal}} in poi: {{percentuale}}',
    senza_iva: 'Senza IVA',
    iva: 'IVA {{percentuale}}',
    ritenuta: 'ritenuta {{aliquota}} sul {{base}}',
    senza_ritenuta: 'senza ritenuta',
    cassa: '{{nome}}: {{nostra}} nostra, {{sua}} sua',
    senza_cassa: 'senza cassa previdenziale',
  },
  scala: {
    etichetta: 'Scala del compenso: {{descrizione}}',
    oggi: 'Oggi è al mese {{mese}}: {{percentuale}}',
    mese: 'mese {{mese}}',
  },
  liquidazioni: {
    periodo: 'Da {{dal}} a {{al}}',
    movimenti_one: '{{count}} movimento',
    movimenti_other: '{{count}} movimenti',
    fattura: 'Fattura {{numero}} del {{data}}',
    pagata_il: 'Pagata il {{data}}',
    costo_nostro: 'Ci costa {{importo}} (con la nostra quota della cassa)',
  },
  dialogo_partner: {
    titolo_nuovo: 'Nuovo partner',
    titolo_modifica: 'Modifica il partner',
    sezione_chi: 'Chi è',
    sezione_fisco: 'Dati fiscali e pagamento',
    sezione_compenso: 'Compenso',
    nome: 'Nome e cognome',
    email: 'Email',
    email_aiuto: 'L\'invito arriva qui, e il partner entra con questo indirizzo (Google o password).',
    email_bloccata: 'Il partner è già entrato: l\'email non si cambia più.',
    lingua: 'Lingua',
    paese: 'Paese',
    paese_aiuto: 'Codice di due lettere, es. IT',
    telefono: 'Telefono',
    tipo_soggetto: 'Tipo di soggetto',
    soggetto_dal_partner: 'Lo indica il partner',
    regime_dopo: 'Da scegliere quando il partner ha dato i suoi dati',
    senza_provvigioni: 'Senza provvigioni',
    senza_provvigioni_aiuto: 'Per l\'account di YumaOS: invita come gli altri partner, le aziende che porta restano sue, ma non matura niente e non ha dati per i pagamenti.',
    ragione_sociale: 'Ragione sociale',
    partita_iva: 'Partita IVA',
    codice_fiscale: 'Codice fiscale',
    iban: 'IBAN',
    profilo: 'Profilo di compenso',
    regime: 'Regime fiscale',
    frequenza: 'Ogni quanto si paga',
    note: 'Note',
    persona_rete: 'Scheda nella Rete',
    nessuna: 'Nessuna',
  },
  lingue: {
    it: 'Italiano',
    en: 'Inglese',
  },
  frequenze: {
    piattaforma: 'Come la piattaforma (ogni 3 mesi)',
    mesi_one: 'Ogni mese',
    mesi_other: 'Ogni {{count}} mesi',
  },
  dialogo_abbina: {
    gia_di: 'Oggi è di {{nome}}.',
    titolo: 'Abbina un\'azienda a un partner',
    aiuto: 'Per le aziende che il partner ha portato prima di avere l\'accesso. Le provvigioni maturano sulle fatture pagate dal giorno indicato.',
    azienda: 'Azienda',
    partner: 'Partner',
    contare_dal: 'Le fatture contano dal',
    sostituisci: 'L\'azienda è di un altro partner: sostituiscilo',
    motivo: 'Perché',
  },
  dialogo_esclusiva: {
    titolo: 'Esclusiva di «{{azienda}}»',
    fino_al: 'In esclusiva fino al',
    fino_al_aiuto: 'Con un giorno già passato l’esclusiva è tolta: anche altri fornitori le possono fare un accordo.',
    motivo: 'Perché',
    salva: 'Salva l’esclusiva',
  },
  dialogo_motivo: {
    rifiuta_titolo: 'Rifiuta «{{azienda}}»',
    motivo: 'Motivo',
    motivo_aiuto: 'Il partner lo legge.',
  },
  dialogo_fattura: {
    titolo: 'Fattura del partner',
    numero: 'Numero',
    data: 'Data',
  },
  dialogo_pagata: {
    titolo: 'Liquidazione pagata',
    data: 'Data del bonifico',
  },
  dialogo_profilo: {
    titolo: 'Nuovo profilo di compenso',
    nome: 'Nome',
    nome_aiuto: 'es. «Romano Paolicelli 2026»',
    dal_mese: 'Dal mese',
    al_mese: 'Al mese',
    percentuale: 'Percentuale',
    per_sempre: 'Per sempre',
  },
  dialogo_regime: {
    titolo: 'Nuovo regime fiscale',
    nome: 'Nome',
    nome_aiuto: 'es. «Società di capitali, Italia»',
    paese: 'Paese',
    con_iva: 'Il partner aggiunge l\'IVA',
    iva: 'IVA %',
    con_ritenuta: 'Tratteniamo la ritenuta d\'acconto',
    aliquota: 'Aliquota %',
    base: 'Sul % della provvigione',
    con_cassa: 'C\'è una cassa previdenziale',
    nome_cassa: 'Nome della cassa',
    quota_nostra: 'Quota nostra %',
    quota_partner: 'Quota del partner %',
  },
  problemi_profilo: {
    nome_mancante: 'Manca il nome.',
    base_sconosciuta: 'Base del compenso sconosciuta.',
    nessuno_scaglione: 'Serve almeno uno scaglione.',
    non_parte_dal_primo_mese: 'Il primo scaglione deve partire dal mese 1.',
    mese_non_valido: 'Lo scaglione {{n}} ha mesi non validi.',
    percentuale_non_valida: 'Lo scaglione {{n}} ha una percentuale non valida (0-100).',
    buco_o_sovrapposizione: 'Lo scaglione {{n}} deve partire dal mese dopo la fine del precedente.',
    scaglione_dopo_per_sempre: 'Dopo uno scaglione «per sempre» non ce ne possono essere altri.',
  },
  kit: {
    aiuto: 'Ciò che i partner possono mandare ai loro contatti: l\'invito a iscriversi, le serie di video, un video, una pagina del sito. Ogni materiale ha i suoi messaggi pronti; il link dentro porta il codice dell\'invito del partner, così chi si iscrive resta suo.',
    destinazione: 'Porta a',
    iscrizione: 'Invito a iscriversi',
    settore: 'Settore: {{settore}}',
    tutti_i_settori: 'Tutti i settori',
    lingua: 'Lingua: {{lingua}}',
    spento: 'Spento',
    breve: 'WhatsApp breve',
    apri: 'Apri la pagina',
  },
  tipo_materiale: {
    iscrizione: 'Invito a iscriversi',
    serie_video: 'Serie di video',
    video: 'Video',
    pagina: 'Pagina del sito',
    pdf: 'PDF',
  },
  dialogo_materiale: {
    titolo_nuovo: 'Nuovo materiale del kit',
    titolo_modifica: 'Correggi il materiale',
    nome: 'Nome',
    nome_aiuto: 'Come lo vede il partner: «Anteprima del preventivo fotovoltaico».',
    descrizione: 'Descrizione',
    descrizione_aiuto: 'Una riga per scegliere: «Cinque video, dodici minuti in tutto».',
    tipo: 'Che cos\'è',
    destinazione: 'Pagina del sito',
    destinazione_aiuto: 'Il percorso su yumaos.com, con la lingua davanti: /it/video/fotovoltaico.',
    settore: 'Settore',
    settore_aiuto: 'Facoltativo, in minuscolo: fotovoltaico, serramenti, climatizzazione.',
    lingua: 'Lingua',
    ordine: 'Ordine',
    attivo: 'Acceso: i partner lo vedono',
    messaggi: 'I messaggi',
    segnaposti: 'Segnaposti: {link} il link d\'invito (obbligatorio), {nome} il nome del contatto, {mittente} chi manda.',
    whatsapp_breve: 'WhatsApp breve',
    whatsapp_lungo: 'WhatsApp lungo',
    email_oggetto: 'Oggetto dell\'email',
    email_testo: 'Testo dell\'email',
    anteprima: 'Anteprima del WhatsApp breve, per Mario da Renato Spiga',
  },
  problemi_materiale: {
    nome_mancante: 'Scrivi il nome.',
    tipo_non_valido: 'Scegli che cos\'è.',
    destinazione_mancante: 'Scrivi la pagina del sito dove porta.',
    destinazione_non_valida: 'La pagina deve essere un percorso di yumaos.com, come /it/video/fotovoltaico.',
    messaggio_mancante: 'Manca il messaggio «{{campo}}».',
    link_mancante: 'Nel messaggio «{{campo}}» manca {link}.',
    segnaposto_sconosciuto: 'Nel messaggio «{{campo}}» c\'è un segnaposto sconosciuto.',
    troppo_lungo: 'Un testo è troppo lungo.',
  },
  messaggi: {
    salvato: 'Salvato.',
    invito_inviato: 'Invito mandato a {{email}}.',
    spazio_aperto: 'Lo spazio di {{nome}} è aperto in una nuova scheda, in sola lettura per 30 minuti.',
    invito_non_inviato: 'L\'invito non è partito: riprova tra poco.',
    ricalcolo_fatto: 'Fatto: {{aziende}} aziende controllate, {{movimenti}} provvigioni nuove, {{bozze}} bozze.',
    errore: 'Operazione non riuscita: {{messaggio}}',
    serve_profilo_e_regime: 'Prima crea almeno un profilo di compenso e un regime fiscale.',
  },
} as const;
